module.exports = __webpack_public_path__ + "img/cp-dash-header.f9fb9a70.jpg";